import { useState } from "react";
import Form from "react-bootstrap/Form";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import "./style.scss";

interface PasswordInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string | undefined;
  disabled?: boolean;
  autoComplete?: string;
}

export default function PasswordInput({
  label,
  value,
  onChange,
  placeholder,
  error,
  disabled = false,
  autoComplete = "new-password",
}: PasswordInputProps) {
  const [show, setShow] = useState(false);

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>

      <div className="input_wrapper">
        <Form.Control
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e?.target?.value || "")}
          autoComplete={autoComplete}
          placeholder={placeholder}
          isInvalid={!!error}
          disabled={disabled}
          className="with-icon"
        />

        <button
          type="button"
          className="eye_button"
          onClick={() => setShow((prev) => !prev)}
        >
          {show ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>

      {error && <div className="invalid-feedback d-block">{error}</div>}
    </Form.Group>
  );
}
